import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { FaEdit, FaSearch, FaTrash } from "react-icons/fa";
import showToast from "../Component/ToastNotification";
import { Toaster } from "react-hot-toast";

function DiscountList() {
  const [products, setProducts] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [discountValue, setDiscountValue] = useState("");
  const [discountId, setDiscountId] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(500);

  const fetchProducts = async () => {
    const token = localStorage.getItem("authToken");
    if (token) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/get-discount`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch categories");
        }

        const result = await response.json();
        setProducts(result.discount || []);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    }
  };
  useEffect(() => {
    fetchProducts();
  }, []);

  const filteredProducts = products.filter((product) =>
    product.ProductName.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentProducts = filteredProducts.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  
  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
  
  useEffect(() => {
    setCurrentPage(1); // Reset to the first page when search term changes
  }, [searchTerm]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleModalClose = () => {
    setSelectedProduct(null);
    setDiscountValue("");
    setShowModal(false);
  };

  const handleAddDiscount = (product) => {
    setDiscountValue(product.DiscountPercentage);
    setSelectedProduct(product);
    setShowModal(true);
  };

  const handleSaveDiscount = async () => {
    const discountPercent = parseFloat(discountValue) || 0;
    if (discountPercent <= 0 || discountPercent > 100) {
      showToast("Enter a valid discount (1-100)", "error");
      return;
    }
    
    const originalPrice = selectedProduct.ProductPrice;
    const discountedPrice = originalPrice * (1 - discountPercent / 100);
    const token = localStorage.getItem("authToken");
    if (!token) return;
    
    const payload = {
      productId: selectedProduct.ProductId,
      discountPercentage: discountPercent,
      discountedPrice: discountedPrice.toFixed(2),
    };
    
    const apiUrl =
      selectedProduct.DiscountPercentage !== "0"
        ? `${process.env.REACT_APP_API_URL}/update-discount`
        : `${process.env.REACT_APP_API_URL}/add-discount`;
    
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
      
      if (!response.ok) throw new Error("Failed to save discount");
      
      showToast(
        selectedProduct.DiscountPercentage !== "0"
          ? "Discount updated successfully!"
          : "Discount added successfully!"
      );
      
      fetchProducts();
      setShowModal(false);
    } catch (error) {
      console.error("Error saving discount:", error);
      showToast("Failed to save discount!", "error");
    }
  };

  const handleDeleteClick = (productId) => {
    setDiscountId(productId);
    setShowDeleteModal(true);
  };

  const handleDeleteDiscount = async () => {
    const token = localStorage.getItem("authToken");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/delete-discount`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ productId: discountId }),
      });
      if (!response.ok) throw new Error("Failed to delete discount");
      showToast("Discount deleted successfully!");
      fetchProducts();
      setShowDeleteModal(false);
    } catch (error) {
      console.error("Error deleting discount:", error);
      showToast("Failed to delete discount!", "error");
    }
  };
  return (
    <div className="container" style={{ marginTop: "80px" }}>
      <Toaster position="top-right" reverseOrder={false} />
      <h2 className="text-primary">Manage Discounts</h2>

      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="input-group me-3" style={{ maxWidth: "300px" }}>
          <span className="input-group-text bg-primary text-white">
            <FaSearch />
          </span>
          <input
            type="text"
            className="form-control"
            placeholder="Search products..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <table className="table table-bordered table-striped">
        <thead className="table-primary">
          <tr>
            <th>Sr. NO.</th>
            <th>Product Name</th>
            <th>Original Price</th>
            <th>Discount Given (%) </th>
            <th>Discounted Price</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentProducts.map((product, index) => (
            <tr key={product.ProductId}>
              <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
              <td>{product.ProductName}</td>
              <td>{product.ProductPrice.toFixed(2)}</td>
              <td>
                {product.DiscountPercentage
                  ? `${product.DiscountPercentage}%`
                  : "-"}
              </td>
              <td>
                {product?.DiscountedPrice
                  ? Number(product.DiscountedPrice).toFixed(2)
                  : "-"}
              </td>
              <td>
                <button
                  className="btn btn-sm btn-outline-success me-2"
                  onClick={() => handleAddDiscount(product)}
                >
                  <FaEdit />{" "}
                  {product.DiscountPercentage !== "0" ? "Edit" : "Add"} Discount
                </button>
                {product.DiscountPercentage && product.DiscountPercentage !== "0" && (
                  <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => handleDeleteClick(product.ProductId)}
                  >
                    <FaTrash /> Delete
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <nav>
        <ul className="pagination justify-content-center">
          {[...Array(totalPages)].map((_, index) => (
            <li
              key={index}
              className={`page-item ${
                currentPage === index + 1 ? "active" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </button>
            </li>
          ))}
        </ul>
      </nav>

      <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedProduct ? `Discount for ${selectedProduct.ProductName}` : ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="discountValue">
              <Form.Label>Discount Amount (%)</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter discount amount"
                value={discountValue}
                onChange={(e) => setDiscountValue(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSaveDiscount}>
            Save Discount
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Discount</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this discount?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteDiscount}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default DiscountList;